import request from '../httpClient';

export const getTeamSettings = (teamId: number) =>
  request.get(`/team_settings/${teamId}`);

export const getStaahTeamSetting = (teamId: number) =>
  request.get(`/team_settings/${teamId}/staah`);

export const updateStaahTeamSetting = (
  teamId: number,
  data: {hotelId: string; username: string; password: string}
) => request.put(`/team_settings/${teamId}/staah`, data);



// WEBPACK FOOTER //
// ./src/services/api/teamSettingApi.ts